let currentSessionId = null;

export const setSessionId = (id) => {
  currentSessionId = id || id === 0 ? String(id) : null;
};

export const getSessionId = () => currentSessionId;

export const clearSessionId = () => {
  currentSessionId = null;
};
